import axios from "axios";
import { apiVariable } from "./apiVariable";
import { CameraCheck } from "../interfaces/Fleet/ICameraCheck";

export const fetchCameraChecksByDriver = async (
  token: string | null | undefined,
  driverId: string,
  month?: number,
  year?: number
): Promise<CameraCheck[]> => {
  const params: Record<string, number> = {};

  if (month) {
    params.month = month;
  }

  if (year) {
    params.year = year;
  }

  const { data } = await axios.get(
    `${apiVariable}/cameraChecks/driver/${driverId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params,
    }
  );
  return data;
};

export const createCameraCheck = async (
  token: string | null | undefined,
  dto: Partial<CameraCheck>
): Promise<CameraCheck> => {
  const { data } = await axios.post(`${apiVariable}/cameraCheck`, dto, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateCameraCheck = async (
  token: string | null | undefined,
  id: string,
  dto: Partial<CameraCheck>
): Promise<CameraCheck> => {
  const { data } = await axios.put(`${apiVariable}/cameraCheck/${id}`, dto, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};
